import { useEffect } from "react";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="flex min-h-[calc(100vh-73px)] items-center justify-center px-4 py-8">
      <div className="max-w-5xl space-y-6 rounded-md border bg-white p-8 text-left text-gray-800">
        <h1 className="mb-4 text-3xl font-bold">Privacy Policy</h1>

        <p>
          <strong>Privacy Policy - Information Collection and Use</strong>
          <br />
          We value your privacy and are committed to protecting your personal information. This privacy policy
          explains in detail how we collect and use your information. By using our services, you consent to
          the collection and use of your information as described below.
        </p>

        <p>
          <strong>Personal Information Collection:</strong>
          <br />
          We collect personal information from you when you register for our service, contact our customer
          support, sign up for newsletters or special offers, and engage in other communications. The personal
          information we collect may include your name, business name, email address, and other related
          information necessary for providing our service. Additionally, we may collect your IP address,
          website visits, and other data typically stored in website logs.
        </p>

        <p>
          <strong>Cookies and Similar Technologies:</strong>
          <br />
          We use cookies and similar technologies to enhance your experience on our website. These
          technologies allow us to collect data and provide you with a more personalized browsing experience.
          You can disable cookies in your browser settings, but please note that some features and
          functionality of our service may be affected.
        </p>

        <p>
          <strong>Information Sharing:</strong>
          <br />
          We do not disclose your personal information to third parties or use it in any way except for
          providing our service, as outlined in our Terms of Use. However, we may share your information with
          third-party service providers who assist us in operating our website and service. These providers
          are obligated to use the information solely for the purpose of performing services on our behalf and
          in compliance with legal requirements. Personal information of users under the age of 12 will not be
          shared with third parties for marketing purposes.
        </p>

        <p>
          <strong>Use of Information:</strong>
          <br />
          We may use your information in the following ways:
        </p>
        <ul className="list-inside list-disc">
          <li>
            To provide and improve our service, including auditing and enhancing its features and
            functionality.
          </li>
          <li>
            To inform you about new features, services, products, promotions, updates, tips, and newsletters.
            You can opt out of receiving these communications by following the unsubscribe instructions in
            each newsletter.
          </li>
          <li>
            To comply with legal obligations, prevent fraud, protect against imminent harm, and ensure the
            security of our services.
          </li>
          <li>
            To share general aggregate non-personal information about our users with potential business
            partners, investors, or the public, with your specific permission.
          </li>
        </ul>

        <p>
          <strong>Information Security:</strong>
          <br />
          We employ industry-standard security measures to protect your information from unauthorized access,
          alteration, disclosure, or destruction. However, no method of transmission or electronic storage is
          100% secure, and we cannot guarantee absolute security. We restrict access to personal information
          to authorized personnel who are bound by confidentiality obligations.
        </p>

        <p>
          <strong>Miscellaneous:</strong>
          <br />
          In the event of a merger, acquisition, or sale of assets, we may transfer the collected information
          to the involved parties. If you believe we have not adhered to this privacy policy, please notify
          us, and we will make commercially reasonable efforts to address the issue.
        </p>

        <p>
          <strong>Changes to Privacy Policy:</strong>
          <br />
          We reserve the right to modify this privacy policy. We will notify registered users of material
          changes by email. It is your responsibility to review the policy periodically.
        </p>

        <p>
          <strong>Contact Information:</strong>
          <br />
          If you have any questions or concerns about our privacy policy, please contact us at{" "}
          <a href="mailto:info@helloworldkids.org" className="text-blue-600 underline">
            info@helloworldkids.org
          </a>
          .
        </p>

        <p>
          <strong>Account Deletion:</strong>
          <br />
          To delete your account, navigate to your account information.
          <br />
          Under the "Basic Data" section, you will find the option to "Delete My Account."
          <br />
          Click on the "Delete My Account" button to initiate the deletion process.
          <br />
          Once you click the button, your account will enter a deletion queue.
          <br />
          To prevent accidental deletions, your account will not be immediately deleted.
          <br />
          We have implemented a waiting period of 4 days during which you should not log in to your account.
          <br />
          Upon initiating the account deletion process, you will receive a confirmation email.
          <br />
          This email will remind you about the deletion waiting period and provide instructions on how to
          cancel the deletion if you change your mind.
          <br />
          After the 4-day waiting period has elapsed with no login activity, your account and associated data
          will be permanently deleted from our system.
          <br />
          Please note that once the deletion process is complete, it cannot be undone.
        </p>

        <p className="font-semibold">
          Note: We do not store, sell, share, rent, or lease any credit/debit card details or personally
          identifiable information to third parties.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
